/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { formatDate } from "utils/formatters";
import { recortarTexto } from "utils/formatters";
import { formatMoneyPunto } from "utils/formatters";
import { makeNiceText } from "utils/formatters";

const getRows = (data, handleOpenMenu) => {
  const coloresEstadoCotizacion = {
    "No iniciada": "secondary",
    "Programada": "uproYellow",
    "En curso": "uproGreen",
    "Cerrada": "dark"
  }

  const coloresEstado = {
    "ANULADO": "error"
  };
      
  const rows = [];
  if (data) {
    data.forEach((item, index) => {

      rows.push({
        hasBorder: index !== data.length - 1,
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.id}
            onClick={(e) => handleOpenMenu(e, item)}
            display="flex"
            alignItems="center"
            gap={0.5}
            pl={1}
          >
            <Tooltip title={item?.fechaAnulacion ? "Anulado": "Pedido"} placement="top">
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color: item?.fechaAnulacion ? getUproColor("secondary") : getUproColor("uproPink"),
                }}
                fontSize="lg"
              >
                {item?.fechaAnulacion ? "close" : "receipt"} 
              </Icon>
            </Tooltip>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox
            sx={{
              cursor: "pointer",
              maxWidth: "600px",
            }}
            data={makeNiceText(item?.nombre , "nombre")}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.nombre
                ? makeNiceText(recortarTexto(item?.nombre, 80), "nombre")
                : "Pedido nº " + item?.id}	
            </SoftTypography>
          </SoftBox>
        ),
        tipoCompra: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.tipoCompra || "No seleccionado"} &nbsp;
            </SoftTypography>
            <Icon sx={{color: getUproColor("uproGreen")}}>
              {{ Directa: "arrow_outward", Concurso: "groups" }[item?.tipoCompra] ?? "block"}
            </Icon>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title={item.motivoAnulacion ?? makeNiceText(item.estado ?? "")}>
              {(item.estadoBase && !Object.keys(coloresEstado).includes(item.estado)) ? (
                <SoftBox display="flex" justifyContent="center">
                  <SoftBox 
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                    borderRadius="md"
                    bgColor={item.estadoBase.area === "Compras" ? getUproColor("uproYellow"): getUproColor("uproGreen")}
                    py={0.4}
                    px={0.5}
                  >
                    <SoftTypography fontSize="0.6rem" variant="caption" color="white">{item.estadoBase.area?.toUpperCase()}</SoftTypography>
                    <SoftBox 
                      display="flex"
                      borderRadius="sm"
                      bgColor="white"
                      px={1}
                      py={0.1}
                    >
                      <SoftTypography fontSize="0.6rem" variant="caption" color="secondary" fontWeight="medium">{item.estadoBase.nombre?.split(" ").slice(0, 3).join(" ")}</SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              ): (
                <SoftBadge 
                  badgeContent={item.estado?.split(" ").slice(0, 5).join(" ")} 
                  color={coloresEstado[item.estado] ?? "dark"}
                />
              )}
            </Tooltip>
          </SoftBox>
        ),
        lastEstadoUpdated: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {formatDate(item?.lastEstadoUpdated, "dd/MM/yyyy hh:mm")}
            </SoftTypography>
          </SoftBox>
        ),
        licitacionEstado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftBadge 
              badgeContent={item.estado === "ANULADO" ? "Anulado" : item.licitacionEstado} 
              color={item.estado === "ANULADO" ? "error" :  coloresEstadoCotizacion[item.licitacionEstado] || "dark"}
            />
          </SoftBox>
        ),
        total: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              $ {formatMoneyPunto(item?.subtotalEstimado)}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "id", desc: "ID", width: "1%", align: "left" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "tipoCompra", desc: "Tipo", align: "center" },
  { name: "estado", desc: "estado", align: "center" },
  { name: "lastEstadoUpdated", desc: "Ult. Vez", align: "center" },
  { name: "licitacionEstado", desc: "Cotización", align: "center", noOrder: true },
  { name: "total", desc: "Total", align: "right" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
